module.exports = __webpack_public_path__ + "img/Dinner_lunch.9fed5636.svg";